import React, { useCallback, useEffect, useRef, useState } from 'react';
import { api } from '../../services/apiService';

interface Props {
  onClick?: () => void;     // typiquement : naviguer vers /chat
}

// Polling adaptatif (60s) pour le badge global de la navbar.
// Beaucoup plus lent que le polling de la vue chat ouverte, car c'est juste
// un compteur informatif.
const POLL_INTERVAL_MS = 60000;

const ChatBadge: React.FC<Props> = ({ onClick }) => {
  const [count, setCount] = useState<number>(0);
  const timerRef = useRef<number | null>(null);

  const refresh = useCallback(async () => {
    try {
      const n = await api.chatUnreadCount();
      setCount(n);
    } catch { /* silencieux : non-bloquant */ }
  }, []);

  useEffect(() => {
    refresh();
    timerRef.current = window.setInterval(() => {
      if (!document.hidden) refresh();
    }, POLL_INTERVAL_MS);
    return () => {
      if (timerRef.current) window.clearInterval(timerRef.current);
    };
  }, [refresh]);

  // Refresh immédiat au retour sur l'onglet
  useEffect(() => {
    const onVis = () => { if (!document.hidden) refresh(); };
    document.addEventListener('visibilitychange', onVis);
    return () => document.removeEventListener('visibilitychange', onVis);
  }, [refresh]);

  return (
    <button
      type="button"
      onClick={onClick}
      title={count > 0 ? `${count} message(s) non lu(s)` : 'Messagerie'}
      aria-label="Messagerie"
      className="relative p-2 rounded-xl hover:bg-white/5 transition-colors"
    >
      <svg className="w-5 h-5 text-slate-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
              d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
      </svg>
      {count > 0 && (
        <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-cyan-500 text-white text-[10px] font-black flex items-center justify-center border-2 border-[var(--orion-bg,#0e1c3a)]">
          {count > 99 ? '99+' : count}
        </span>
      )}
    </button>
  );
};

export default ChatBadge;
